import { hashCode } from '@piri/utils';

export function hashUrl(url) {
  return hashCode(decodeURI(url)
    .replace(' ', ''));
}

export function stripHtml(content) {
  return content
    .replace(/(<\/?(?: | | )[^>]*>)|<[^>]+>/gi, '$1')
    .replace(/(^\s+|\s+$)/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&hellip;/g, '...')
    .trim();
}
